import { createMessage, SB } from '@play-co/replicant';
import { gemGiftAmount } from './gifts.ruleset';
import createMessages from '../config/messages/createMessages';

export default createMessages({
  /**
   * Add gifts to user state
   */
  receiveGift: createMessage(
    SB.object({}),
    (state, _, { senderId, timestamp }) => {
      // Only rewards listed in gifts.received schema should be allowed here.
      let rewards: { bPoints: number } | { gems: number };

      // Since puzzleCoins is resolved, user should get gems as gift instead of bPoints
      rewards = { gems: gemGiftAmount };

      // Create gift on user state
      state.gifts.received[senderId] = {
        sentAt: timestamp,
        ...rewards,
      };
    },
  ),

  /**
   * Add batched gifts to user state
   */
  batchGiftOA: createMessage(SB.object({}), (state, _) => {
    state.gifts.giftBatchCount += 1;
  }),
});
